import { signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase/config";

export const PENDING_VERIFICATION_KEY = "atomicpay.pendingEmailVerification";

export function pendingVerificationEmail() {
  try {
    return sessionStorage.getItem(PENDING_VERIFICATION_KEY) || "";
  } catch {
    return "";
  }
}

export function rememberPendingVerificationEmail(email) {
  if (!email) return;
  try {
    sessionStorage.setItem(PENDING_VERIFICATION_KEY, email);
  } catch {
    // Session storage can be blocked. The sign-out still stands.
  }
}

export function clearPendingVerificationEmail() {
  try {
    sessionStorage.removeItem(PENDING_VERIFICATION_KEY);
  } catch {
    // Ignore storage failures.
  }
}

export async function accountMustVerifyEmail(user) {
  if (!user || user.emailVerified) return false;
  try {
    const snap = await getDoc(doc(db, "users", user.uid));
    if (!snap.exists()) return true;
    return snap.data()?.emailVerificationRequired === true;
  } catch (error) {
    console.error("email verification lookup failed", error);
    return false;
  }
}

export async function signOutIfUnverified(user) {
  if (!(await accountMustVerifyEmail(user))) return false;
  rememberPendingVerificationEmail(user.email);
  await signOut(auth).catch(() => {});
  return true;
}
